import { createSelector } from "@reduxjs/toolkit";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Component } from "react";
import React from "react";
import { string } from "yup";

import { RootState } from "..";
import { defaultCountry } from "../../shared";

import { UIState } from "./genericUI.slice";

export const selectIsDefaultCountrySelected = (
  uiDataSelector: (state: RootState) => UIState
) => (id: string): ((state: RootState) => boolean) =>
  createSelector(uiDataSelector, (field: UIState) => {
    if (field[id] === undefined) {
      return false;
    }

    return field[id] !== defaultCountry.value;
  });

export const selectIsNotDefaultCountrySelected = (
  uiDataSelector: (state: RootState) => UIState
) => (id: string): ((state: RootState) => boolean) =>
  createSelector(uiDataSelector, (field: UIState) => {
    if (field[id] === undefined) {
      return true;
    }

    return field[id] === defaultCountry.value;
  });

export const selectCountry = (
  uiDataSelector: (state: RootState) => UIState
) => (id: string): ((state: RootState) => string) =>
  createSelector(
    uiDataSelector,
    (field) =>
      ((field[id] as unknown) as Record<string, string>)?.country ||
      defaultCountry.value.toLowerCase()
  );

export const selectIsFormValidated = (
  uiDataSelector: (state: RootState) => UIState
): ((state: RootState) => boolean) =>
  createSelector(uiDataSelector, (data) => data.validated === true);
